"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var create_exports = {};
__export(create_exports, {
  bounds: () => bounds,
  customRule: () => customRule,
  forbiddenIf: () => forbiddenIf,
  forbiddenIfV2: () => forbiddenIfV2,
  matchesRegex: () => matchesRegex,
  maxTimestamp: () => maxTimestamp,
  maxValue: () => maxValue,
  minTimestamp: () => minTimestamp,
  minValue: () => minValue,
  oneOf: () => oneOf,
  required: () => required,
  requiredIf: () => requiredIf,
  requiredIfV2: () => requiredIfV2,
  requiredIff: () => requiredIff,
  rule: () => rule,
  timestampBounds: () => timestampBounds,
  totals: () => totals
});
module.exports = __toCommonJS(create_exports);
var import_guard = require("@cartographerio/guard");
var import_expr = require("../expr/index.js");
var import_pass = require("./pass.js");
var import_text = require("./text.js");
function required(level = "error", message) {
  return { type: "RequiredRule", level, message };
}
function rule(args) {
  return { type: "CustomRule", ...args };
}
function minValue(minValue2, level = "error", message) {
  return { type: "BoundsRule", minValue: minValue2, level, message };
}
function maxValue(maxValue2, level = "error", message) {
  return { type: "BoundsRule", maxValue: maxValue2, level, message };
}
function bounds(minValue2, maxValue2, level = "error", message) {
  return { type: "BoundsRule", minValue: minValue2, maxValue: maxValue2, level, message };
}
function minTimestamp(minValue2, level = "error", validateTime = true, message) {
  return {
    type: "TimestampBoundsRule",
    minValue: minValue2,
    validateTime,
    level,
    message
  };
}
function maxTimestamp(maxValue2, level = "error", validateTime = true, message) {
  return {
    type: "TimestampBoundsRule",
    maxValue: maxValue2,
    validateTime,
    level,
    message
  };
}
function timestampBounds(minValue2, maxValue2, level = "error", validateTime = true, message) {
  return {
    type: "TimestampBoundsRule",
    minValue: minValue2,
    maxValue: maxValue2,
    validateTime,
    level,
    message
  };
}
function totals(path, minValue2, maxValue2, level = "error") {
  return rule({
    level,
    triggerWhen: (0, import_expr.topoExpr)((env) => {
      const value = env.get(path);
      return (0, import_guard.isRecordOf)(import_guard.isString, (0, import_guard.isOptional)(import_guard.isNumber))(value) && !(0, import_pass.boundsRulePasses)(
        minValue2,
        maxValue2,
        Object.values(value).reduce((a, b) => (a ?? 0) + (b ?? 0), 0)
      );
    }),
    message: (0, import_text.boundsRuleDefaultMessage)(level, minValue2, maxValue2, `The total`)
  });
}
function customRule(opts) {
  return { type: "CustomRule", ...opts };
}
function requiredIf(opts) {
  const { level = "error", message, blankTest = (value) => value == null, otherPath, otherTest } = opts;
  return {
    type: "CustomRule",
    level,
    message,
    triggerWhen: (0, import_expr.topoExpr)((env) => blankTest(env.getFocused()) ? otherTest(env.get(otherPath)) : false)
  };
}
function requiredIfV2(opts) {
  const { level = "error", message, blankTest = (value) => value == null, otherTest } = opts;
  return {
    type: "CustomRule",
    level,
    message,
    triggerWhen: (0, import_expr.topoExpr)((env, run) => blankTest(env.getFocused()) ? run(otherTest) : false)
  };
}
function forbiddenIf(opts) {
  const { level = "error", message, blankTest = (value) => value == null, otherPath, otherTest } = opts;
  return {
    type: "CustomRule",
    level,
    message,
    triggerWhen: (0, import_expr.topoExpr)((env) => blankTest(env.getFocused()) ? false : otherTest(env.get(otherPath)))
  };
}
function forbiddenIfV2(opts) {
  const { level = "error", message, blankTest = (value) => value == null, otherTest } = opts;
  return {
    type: "CustomRule",
    level,
    message,
    triggerWhen: (0, import_expr.topoExpr)((env, run) => blankTest(env.getFocused()) ? false : run(otherTest))
  };
}
function requiredIff(opts) {
  const {
    level,
    requiredLevel = level,
    forbiddenLevel = level,
    requiredMessage,
    forbiddenMessage,
    enabled = (0, import_expr.topoExpr)((_) => true),
    blankTest = (value) => value == null,
    otherPath,
    otherTest
  } = opts;
  return [
    requiredIfV2({
      level: requiredLevel,
      message: requiredMessage,
      blankTest,
      otherTest: (0, import_expr.topoExpr)(
        (env, run) => run(enabled) ? blankTest(env.getFocused()) ? otherTest(env.get(otherPath)) : false : false
      )
    }),
    forbiddenIfV2({
      level: forbiddenLevel,
      message: forbiddenMessage,
      blankTest,
      otherTest: (0, import_expr.topoExpr)(
        (env, run) => run(enabled) ? blankTest(env.getFocused()) ? false : !otherTest(env.get(otherPath)) : false
      )
    })
  ];
}
function matchesRegex(opts) {
  const { level = "error", message, regex } = opts;
  return {
    type: "CustomRule",
    level,
    message,
    triggerWhen: (0, import_expr.topoExpr)((env) => {
      const value = env.getFocused();
      return typeof value === "string" && !regex.test(value);
    })
  };
}
function oneOf(opts) {
  const { level = "error", message = "You must choose one of the options", options } = opts;
  return {
    type: "CustomRule",
    level,
    message,
    triggerWhen: (0, import_expr.topoExpr)((env) => !options.includes(env.getFocused() ?? null))
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  bounds,
  customRule,
  forbiddenIf,
  forbiddenIfV2,
  matchesRegex,
  maxTimestamp,
  maxValue,
  minTimestamp,
  minValue,
  oneOf,
  required,
  requiredIf,
  requiredIfV2,
  requiredIff,
  rule,
  timestampBounds,
  totals
});
//# sourceMappingURL=create.js.map
